export default __webpack_public_path__ + "02f1419.png";